import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Space, Modal, Checkbox, Collapse, Table, Tag, InputNumber, notification, Alert } from 'antd';
import { PlusOutlined, FilterOutlined, CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import Swal from "sweetalert2";

import "./style.scss";
import { cloneDeep } from "lodash";                           

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const AddEventItem = ({ userStore, voterStore, eventStore }) => {

    const [form] = Form.useForm();
    const [formEdit] = Form.useForm();
    const navigate = useNavigate();

    let { id } = useParams();

    // DATA FOR THE LOCALSTORAGE
    const [items, setItems] = useState([]);
    const [pricePerUnit, setPricePerUnit] = useState(0);

    const [searchName, setSearchName] = useState();
    const [searchStreet, setSearchStreet] = useState();
    const [searchAddress, setSearchAddress] = useState();
    const [searchGender, setSearchGender] = useState();
    const [searchPWD, setSearchPWD] = useState(false);

    const [hasGender, setHasGender] = useState(false);
    const [hasStreet, setHasStreet] = useState(false);
    const [hasAddress, setHasAddress] = useState(false);
    const [hasPWD, setHasPWD] = useState(false);

    const [selectedVoter, setSelectedVoter] = useState()
    const [topUpSelectedVoter, setTopUpSelectedVoter] = useState([]);

    const [isOpenForm, setIsOpenForm] = useState(false);
    const [isOpenEditForm, setIsOpenEditForm] = useState(false);

    const [total, setTotal] = useState(0);

    useEffect(() => {
        const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
        const storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];

        if (!storedDataItems || storedDataItems.length === 0) {
            userStore.fetchUserLoadsTeamLeaderStatus(login_user.userID).then(() => {
                localStorage.setItem(`itemdata_${id}`, JSON.stringify(userStore.userLoadsItems));
            });
        }

    }, [])

    useEffect(() => {
        const newTotal = topUpSelectedVoter.reduce((sum, item) => sum + parseFloat(item.amount), 0);
        setTotal(newTotal);
    }, [topUpSelectedVoter]);

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem(`ayudaitems_${id}`)) || [];

        setTopUpSelectedVoter(storedData);

        if(storedData.length > 0){
            storedData.forEach((ayuda) => {
                setTotal(total + parseInt(ayuda.amount))
            })
        }

        if(selectedVoter) {
            form.setFieldsValue(selectedVoter)
        }

        const storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];
        setItems(storedDataItems);

    }, [selectedVoter])

    useEffect(() => {

        const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];

        voterStore.page = 1;
        voterStore.hasMore = false;
        voterStore.perPage = 5;
        voterStore.fetchVoters();
        if (id) {
            eventStore.fetchEventByID(id);
        }

        if (login_user.userID) {
            userStore.fetchUserByID(login_user.userID);
        }

    }, [])

    // FOR MODAL ADDING OF NEW ITEM TO USER -------------------------------
    const handleItemChange = (value) => {
        const selectedItem = items.find(item => item.UserLoadID === value);
        if (selectedItem) {
            setPricePerUnit(parseFloat(selectedItem.PricePerUnit)); // Store price internally
            form.setFieldsValue({
                quantity: 1, // Default quantity
                amount: parseFloat(selectedItem.PricePerUnit) * 1, // Initial amount calculation
                item: selectedItem.UserLoadID // Store UserLoadID in form
            });
        }
    };
    
    const calculateAmount = () => {
        const quantity = form.getFieldValue('quantity') || 0;
        form.setFieldsValue({ amount: pricePerUnit * quantity });
    };

    // FOR MODAL ADDING OF NEW ITEM TO USER -------------------------------
    
    const handlePrevPage = () => {
        voterStore.page = voterStore.page - 1;
        voterStore.fetchVoters();
    };
    
    const handleNextPage = () => {
        voterStore.page = voterStore.page + 1;
        voterStore.fetchVoters();
    };

    const handleSearchVoter = () => {
        if (!searchName && !searchStreet && !searchAddress && !searchGender && !searchPWD) {
          notification.error({
            top: 120,
            message: 'Error!',
            description: 'Please provide proper data for accurate results.'
          });
          return;
        } else if(searchName == ""){
            notification.error({
              top: 120,
              message: 'Error!',
              description: 'Please provide a Voter Name'
            });
            return;
        } else{
    
          const searchParams = {};
          if (searchName) searchParams.name = searchName;
          if (searchStreet) searchParams.street = searchStreet;
          if (searchAddress) searchParams.address = searchAddress;
          if (searchGender) searchParams.gender = searchGender;
          if (searchPWD) searchParams.pwd = searchPWD;
    
          voterStore.searchVotersMultipleData(searchParams);
        }
    };
    

    const formatNumber = (formatnumber) => {
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(formatnumber);
    };

    const columns = [
        {
            title: 'Name',
            key: 'FullName+ID',
            dataIndex: 'FullName',
            responsive: ['lg', 'xl', 'md'],
            render: (FullName) => (
              <Text default>{FullName}</Text>
            )
          },
          {
            title: 'Street',
            key: 'Street+ID',
            dataIndex: 'Street',
            responsive: ['lg', 'xl', 'md'],
            render: (Street) => (
              <Text default>{Street}</Text>
            )
          },
          {
            title: 'Address',
            key: 'Address+ID',
            dataIndex: 'Address',
            responsive: ['lg', 'xl', 'md'],
            render: (Address) => (
              <Text default>{Address}</Text>
            )
          },
          {
            title: 'Gender',
            key: 'Sex+ID',
            dataIndex: 'Sex',
            responsive: ['lg', 'xl', 'md'],
            width: '15%',
            render: (Sex) => (
              <Text default>{Sex}</Text>
            )
          },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => {
                        setSelectedVoter(null); // Reset before selecting
                        form.resetFields(); // Reset form fields

                        // If not selected, proceed with selection
                        setSelectedVoter(record);
                        setIsOpenForm(true); // Open the modal
                    }}
                >Select</Button>
            </Space>
          )
        },
    ];

    const columnsAyuda = [
        {
            title: 'Name',
            key: 'FullName',
            dataIndex: 'FullName',
            responsive: ['lg', 'xl', 'md'],
            render: (FullName) => (
            <Text default>{FullName}</Text>
            )
        },
        {
            title: 'Item',
            key: 'itemName',
            dataIndex: 'itemName',
            responsive: ['lg', 'xl', 'md'],
            render: (itemName) => (
                <Text default>{itemName}</Text>
            )
        },
        {
            title: 'Price per Unit',
            key: 'itemPricePerUnit',
            dataIndex: 'itemPricePerUnit',
            responsive: ['lg', 'xl', 'md'],
            render: (itemPricePerUnit) => (
                <Text default>₱ {formatNumber(itemPricePerUnit)}</Text>
            )
        },
        {
            title: 'Quantity',
            key: 'quantity',
            dataIndex: 'quantity',
            responsive: ['lg', 'xl', 'md'],
            render: (quantity) => (
                <Text default>{quantity}</Text>
            )
        },
        {
            title: 'Total Amount',
            key: 'amount',
            dataIndex: 'amount',
            responsive: ['lg', 'xl', 'md'],
            render: (amount) => (
                <Text default>₱ {formatNumber(amount)}</Text>
            )
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost 
                    onClick={() => {
                        formEdit.setFieldsValue(record)
                        setSelectedVoter(record)
                        setIsOpenEditForm(true)
                    }}
                >Edit</Button>
                <Modal 
                    title="Edit Details" 
                    open={isOpenEditForm} 
                    onOk={() => {
                        formEdit.submit();
                    }}
                    onCancel={() => setIsOpenEditForm(false)}
                    afterOpenChange={(visible) => {
                        if (visible && selectedVoter) {
                            formEdit.setFieldsValue({
                                quantity: selectedVoter.quantity,
                                item: selectedVoter.item,
                            });
                        }
                    }}
                >
                    <Form
                        name="editForm"
                        layout="vertical"
                        form={formEdit} 
                        onFinish={onFinishEdit}
                    >

                        {/* Get the selected item and calculate available stock */}
                        {formEdit.getFieldValue('item') && (() => {
                            const selectedItem = items.find(i => i.UserLoadID  === formEdit.getFieldValue('item'));
                            const previousQuantity = selectedVoter?.quantity || 0; // Get the user's previous quantity
                            const availableStock = selectedItem ? selectedItem.Quantity + previousQuantity : 0;

                            return (
                                <>
                                  
                                    <Form.Item 
                                        label="Quantity" 
                                        name="quantity"
                                        rules={[
                                            { required: true, message: 'Please enter quantity.' },
                                            () => ({
                                                validator(_, value) {
                                                    if (value > availableStock) {
                                                        return Promise.reject(new Error(`Max available quantity: ${availableStock}`));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <InputNumber 
                                            placeholder="Enter Quantity" 
                                            style={{ width: "100%" }} 
                                            min={1}
                                            max={availableStock} // Set max dynamically
                                        />
                                    </Form.Item>
                                </>
                            );
                        })()}
                    </Form>
                </Modal>
                <Button type="primary" ghost danger onClick={() => handleDelete(record.id)}>Delete</Button>
            </Space>
            )
        },
    ];

    const onFinish = (values) => {
        
        const storedData = JSON.parse(localStorage.getItem(`ayudaitems_${id}`)) || [];
        let storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];

        // CHECK THE SELECTED ITEM FROM THE LIST OF ARRAY 
        const selectedItem = storedDataItems.find(item => item.UserLoadID === values.item);

        const datapost = {
            ...values,
            itemName: selectedItem.ItemName,
            itemPricePerUnit: selectedItem.PricePerUnit,
            itemDescription: selectedItem.Description,
            itemTotalAmount: selectedItem.Amount,
            itemReleasedQuantity: selectedItem.ReleasedQuantity,
        }

        // Ensure selected item exists and has enough quantity
        if (!selectedItem || parseInt(values.quantity) > parseInt(selectedItem.Quantity)) {
            notification.error({
                message: "Quantity Error",
                description: `Insufficient stock for ${selectedItem ? selectedItem.ItemName : "selected item"}. Available: ${selectedItem ? selectedItem.Quantity : 0}`,
                top: 120,
            });
            return;
        }

        const newEntry = { id: Date.now(), ...selectedVoter, ...datapost }

        // Prevent the same user from selecting the same item again
        if (storedData.some(item => item.FullName === newEntry.FullName && item.item === newEntry.item)) {
            notification.warning({
                message: "Duplicate Entry",
                description: `${newEntry.FullName} has already selected for ${newEntry.itemName} distribution.`,
                top: 120,
            });
            return;
        }
        
        const updatedList = [...storedData, { id: topUpSelectedVoter.length + 1, ...selectedVoter, ...datapost }];
        setTopUpSelectedVoter(updatedList);

        // Deduct quantity from inventory
        storedDataItems = storedDataItems.map(item => {
            if (item.UserLoadID === values.item) {
                return {
                    ...item,
                    Quantity: String(Math.max(0, parseInt(item.Quantity) - parseInt(values.quantity))),
                };
            }
            return item;
        });

        // Update total amount
        let total = updatedList.reduce((sum, item) => sum + parseInt(item.amount), 0);
        setTotal(total);

        // Save updated data to localStorage
        localStorage.setItem(`ayudaitems_${id}`, JSON.stringify(updatedList));
        localStorage.setItem(`itemdata_${id}`, JSON.stringify(storedDataItems));
    
        form.resetFields();
    };

    const onFinishEdit = (values) => {
        const storedData = JSON.parse(localStorage.getItem(`ayudaitems_${id}`)) || [];
        let storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];
    
        // Find the previous data
        const previousData = storedData.find(item => item.id === selectedVoter.id);
        if (!previousData) {
            notification.error({
                message: "Error",
                description: "Selected voter data not found.",
                top: 120,
            });
            return;
        }
    
        const previousQuantity = parseInt(previousData.quantity);
        const newQuantity = parseInt(values.quantity);
        const pricePerUnit = parseFloat(previousData.itemPricePerUnit);
    
        // If quantity hasn't changed, close the modal and return
        if (previousQuantity === newQuantity) {
            setIsOpenEditForm(false);
            return;
        }
    
        // Get the selected item from inventory
        const selectedItem = storedDataItems.find(item => item.UserLoadID === previousData.item);
        if (!selectedItem) {
            notification.error({
                message: "Error",
                description: "Selected item not found in inventory.",
                top: 120,
            });
            return;
        }
    
        // Calculate available stock (including the previously allocated quantity)
        const availableStock = Number(selectedItem.Quantity) + Number(previousQuantity);
    
        // Check if the new quantity exceeds available stock
        if (newQuantity > availableStock) {
            notification.error({
                message: "Quantity Error",
                description: `Not enough stock for ${previousData.itemName}. Available stock: ${availableStock}`,
                top: 120,
            });
            return;
        }
    
        // Update the voter's quantity and amount
        const updatedList = storedData.map(item =>
            item.id === selectedVoter.id
                ? { ...item, quantity: newQuantity, amount: newQuantity * pricePerUnit }
                : item
        );
    
        // Update the inventory quantity
        const updatedItems = storedDataItems.map(item => {
            if (item.UserLoadID  === previousData.item) {
                return {
                    ...item,
                    Quantity: String(Number(item.Quantity) + Number(previousQuantity) - Number(newQuantity)),
                };
            }
            return item;
        });
    
        // Recalculate the total amount
        const newTotal = updatedList.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    
        // Update state and local storage
        setTopUpSelectedVoter(updatedList);
        setTotal(newTotal);
        localStorage.setItem(`ayudaitems_${id}`, JSON.stringify(updatedList));
        localStorage.setItem(`itemdata_${id}`, JSON.stringify(updatedItems));
    
        // Close the modal and reset the form
        setIsOpenEditForm(false);
        formEdit.resetFields();
    };

    const handleDelete = (voterId) => {
        const storedData = JSON.parse(localStorage.getItem(`ayudaitems_${id}`)) || [];
        let storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];

        // Find the item being deleted
        const deletedItem = storedData.find(item => item.id === voterId);

        if (!deletedItem) return;

        // Filter out the voter to delete
        const updatedList = storedData.filter(item => item.id !== voterId);

        // Restore quantity in the inventory
        storedDataItems = storedDataItems.map(item => {
            if (item.UserLoadID === deletedItem.item) {
                return {
                    ...item,
                    Quantity: String(parseInt(item.Quantity) + parseInt(deletedItem.quantity)), // Add back quantity
                };
            }
            return item;
        });

        // Update the total amount
        const newTotal = updatedList.reduce((sum, item) => sum + parseInt(item.amount), 0);

        // Update state
        setTopUpSelectedVoter(updatedList);
        setTotal(newTotal);

        // Save updated lists back to localStorage
        localStorage.setItem(`ayudaitems_${id}`, JSON.stringify(updatedList));
        localStorage.setItem(`itemdata_${id}`, JSON.stringify(storedDataItems));
    };

    const handleTopupVoters = () => {
        const storedData = JSON.parse(localStorage.getItem(`ayudaitems_${id}`)) || [];
        let storedDataItems = JSON.parse(localStorage.getItem(`itemdata_${id}`)) || [];

        if(storedData.length == 0){
            notification.error({
                top: 120,
                message: 'Top Up Error',
                description: 'No Voters selected for Top Up amount.'
            });
            return;
        }

        // Check if inventory has enough stock before processing
        const insufficientItems = storedData.some(item => {
            const inventoryItem = storedDataItems.find(i => i.UserLoadID === item.item);

            return !inventoryItem || parseInt(inventoryItem.Quantity) < parseInt(item.quantity);
        });

        if (insufficientItems) {
            notification.error({
                top: 120,
                message: 'Stock Error',
                description: 'Not enough stock available for one or more selected items.',
            });
            return;
        }

        const transformedData = storedData.map((item) => ({
            votersID: item.ID,
            votersName: item.FullName,
            eventID: eventStore.event.EventID,
            eventName: eventStore.event.EventName,  
            type: 'ITEM',
            itemName: item.itemName,
            description: item.itemDescription,
            quantity: item.quantity,
            releasedQuantity: item.itemReleasedQuantity,
            priceperunit: item.itemPricePerUnit,
            amount: item.amount, 
            totalAmount: item.itemTotalAmount,
            userLoadID: item.item,
        }));

        
        if(userStore.teamLeader.itemAmount >= total) {
            eventStore.topupVotersItem(transformedData, id);
        } else{
            notification.error({
                top: 120,
                message: 'Wallet Amount Error!',
                description: 'Not enough balance. Please double-check your current wallet balance before submitting the list of voter amounts.'
            });

            Swal.fire({
                title: "Wallet Amount Error",
                icon: "error",
                text: "Not enough balance. Please double-check your current wallet balance before submitting the list of voter amounts.",
                showCancelButton: false,
                confirmButtonText: "Okay",
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                } 
            })

            return;
        }

    };

    return (
        <div className="admin-add-event-ayuda">
            <Content>
                <div className="admin-add-ayuda-content">
                    <Title level={5}><FilterOutlined /> Filter Voters</Title>
                    <Row gutter={[10, 10]} className="filters">
                        <Col span={8}>
                            <Input
                                placeholder="Enter name"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </Col>
                        {hasGender && (
                            <Col span={8}>
                            <Select
                                options={[
                                    { value: 'Male', label: 'Male' },
                                    { value: 'Female', label: 'Female' }
                                ]}
                                placeholder="Select Gender"
                                size="large"
                                onChange={(value) => setSearchGender(value)}
                            />
                            </Col>
                        )}
                        {hasStreet && (
                            <Col span={8}>
                            <Input
                                placeholder="Enter Street"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchStreet(e.target.value)}
                            />
                            </Col>
                        )}
                        {hasAddress && (
                            <Col span={8}>
                            <Input
                                placeholder="Enter Address"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchAddress(e.target.value)}
                            />
                            </Col>
                        )}
                        {hasPWD && (
                            <Col>
                            <Checkbox
                                checked={searchPWD}
                                onChange={(e) => setSearchPWD(e.target.checked)}
                            > Is it a Person with disabilities?</Checkbox>
                            </Col>
                        )}
                    </Row>
                    <Button type="primary" icon={<FilterOutlined />} onClick={handleSearchVoter}>Search Voter</Button>
                    <Collapse className="add-more-filters-collapse">
                        <Panel header={<>Add more filters?</>} style={{width: "100%"}}>
                            <Row gutter={15}>
                                <Col>
                                    <Checkbox 
                                    checked={hasGender}
                                    onChange={() => setHasGender(!hasGender)}
                                    >Gender</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasStreet}
                                    onChange={() => setHasStreet(!hasStreet)}
                                    >Street</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasAddress}
                                    onChange={() => setHasAddress(!hasAddress)}
                                    >Address</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasPWD}
                                    onChange={() => setHasPWD(!hasPWD)}
                                    >PWD</Checkbox>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                    <Divider/>
                    <Table pagination={false} columns={columns} dataSource={cloneDeep(voterStore.voters)} bordered/>
                    <ul className="pagination">
                        <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                        <li className="pagination-item"><a>{voterStore.page}</a></li>
                        <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                    </ul>
                </div>
            </Content>
            <Content>
            <Modal 
                title="Give Ayuda Form" 
                open={isOpenForm} 
                onOk={() => {
                    form.submit();
                    setIsOpenForm(false);
                }}
                onCancel={() => setIsOpenForm(false)}
            >
                <Form 
                    name="addbillingInformationForm"
                    layout="vertical"
                    form={form} 
                    onFinish={onFinish}
                >
                    {/* Items Dropdown */}
                    <Form.Item
                        label="Items"
                        name="item"
                        rules={[{ required: true, message: 'Please select an item.' }]}
                    >
                        <Select 
                            placeholder="Select Item"
                            onChange={handleItemChange}
                        >
                            {items.map(item => (
                                <Select.Option key={item.UserLoadID} value={item.UserLoadID}>
                                    {item.ItemName + " (₱" + formatNumber(item.PricePerUnit) + ") - " + item.Quantity +" available"}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {/* Quantity Input */}
                    <Form.Item
                        label="Quantity"
                        name="quantity"
                        rules={[
                            { required: true, message: 'Please input quantity.' },
                            () => ({
                                validator(_, value) {
                                    const selectedItem = items.find(i => i.UserLoadID === form.getFieldValue('item'));
                                    if (selectedItem && value > selectedItem.Quantity) {
                                        return Promise.reject(new Error(`Maximum available quantity: ${selectedItem.Quantity}`));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <InputNumber
                            min={1}
                            style={{ width: "100%" }}
                            onChange={calculateAmount}
                            max={items.find(i => i.ItemName === form.getFieldValue('item'))?.Quantity || 1} // Set max dynamically
                        />
                    </Form.Item>

                    {/* Amount Field - Auto-calculated but editable */}
                    <Form.Item
                        label="Amount"
                        name="amount"
                        rules={[{ required: true, message: 'Please input Amount.' }]}
                    >
                        <InputNumber 
                            placeholder="Enter Amount" 
                            style={{ width: "100%" }}
                        />
                    </Form.Item>

                    <Divider/>
                </Form>
            </Modal>
                <div className="admin-add-ayuda-content">
                    <Title level={4}>List of Distributed Items</Title>
                    <Divider/>
                    <Row justify={'start'}>
                        <Space>
                            <Title level={4} strong>Current Wallet Amount: </Title><Title level={4} strong type="success">₱ {formatNumber(userStore.teamLeader && userStore.teamLeader.itemAmount)}</Title>
                        </Space>
                    </Row>
                    <Table pagination={false} columns={columnsAyuda} dataSource={cloneDeep(topUpSelectedVoter)} bordered/>
                    <Row justify={'end'}>
                        <Space>
                            <Title level={4} strong>Total Top Up Amount: </Title><Title level={4} strong type="danger">₱ {formatNumber(total)}</Title>
                        </Space>
                    </Row>
                    <Divider/>
                    <Row justify={'end'} gutter={12}>
                        <Col>
                            <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={userStore.loading} onClick={handleTopupVoters}>Submit</Button>
                        </Col>
                        <Col>
                            <Button onClick={() => navigate(-1)} loading={userStore.loading}>Back</Button>
                        </Col>
                    </Row>
                </div>
            </Content>
        </div>
    );
};

export default inject('userStore', 'voterStore', 'eventStore')(observer(AddEventItem));
